import React from "react"
import PropTypes from "prop-types"
import {Card, Col, Row} from "antd"
import PersonTable from "../person/PersonTable";
import {DetailsTitle, StatusIndication, TextAligned, NavTo} from "../../util/Util";
import {bindActionCreators} from "redux";
import * as SiteActions from "../../reducers/site"
import {connect} from "react-redux";
import SiteCustomerSelectionTable from "../site/SiteCustomerSelectionTable";

class SiteDetails extends React.Component {

    static propTypes = {
        findSite: PropTypes.func.isRequired,
        site: PropTypes.object.isRequired,
        findingSite: PropTypes.bool.isRequired
    };

    componentDidMount() {
        const {match, findSite} = this.props;
        const urlId = match.params.id;
        findSite(urlId);
    }

    renderAddress = (site) => {
        if (site.visitCity === site.mailCity && site.visitStreet === site.mailStreet && site.visitPostalCode === site.mailPostalCode) {
            return this.renderSingleAddress('Visit & Mail Address', site.visitCity, site.visitStreet, site.visitPostalCode)
        } else return <div>
            {this.renderSingleAddress('Visit Address', site.visitCity, site.visitStreet, site.visitPostalCode)}
            <br/>
            {this.renderSingleAddress('Mail Address', site.mailCity, site.mailStreet, site.mailPostalCode)}
        </div>
    };

    renderSingleAddress = (title, city, street, zip) => <div>
        <h4>{title}</h4>
        <TextAligned label="City" value={city}/>
        <TextAligned label="Street" value={street}/>
        <TextAligned label="Zip" value={zip}/>
    </div>;

    render() {
        const {findingSite} = this.props;
        const {site, persons, specialties, kol, hierarchyUp, hierarchyDown, siteCustomerSelection} = this.props.site;
        return <Card title={<DetailsTitle icon="home">{site.siteName4 || ''} {site.siteName5 || ''}</DetailsTitle>}
                     loading={findingSite}>
            <Row gutter={20}>
                <Col span={5}>
                    <TextAligned label="Site Name" value={site.siteName5}/>
                    <TextAligned label="Department" value={site.siteName4}/>
                    <TextAligned label="Type" value={site.type}/>
                    <TextAligned label="Status" value={<StatusIndication active={site.active}/>}/>
                    <TextAligned label="Number of Affiliations" value={persons.length}/>
                    <br/>
                    <TextAligned label="County" value={site.county}/>
                    <TextAligned label="Commune" value={site.commune}/>
                    <br/>
                    {this.renderAddress(site)}
                    <br/>
                    <TextAligned label="Phone" value={site.tele}/>
                    <TextAligned label="Fax" value={site.fax}/>
                    <TextAligned label="Webpage"  value={<NavTo containes={false} link={site.webpage}/>}/>
                    <br/>
                    <TextAligned label="Source" value={site.dbSource}/>
                    <TextAligned label="Created" value={site.ct}/>
                    <TextAligned label="Updated" value={site.ut}/>
                    <TextAligned label="Validated" value={site.vt}/>
                    <TextAligned label="Site ID" value={site.id}/>
                    <TextAligned label="aPureBase ID" value={site.apurebaseId}/>
                </Col>
                <Col span={4}>
                    <Card title="Specialties">
                        {specialties.map(spc => <p key={spc}>{spc}</p>)}
                    </Card>
                    <Card title="Site KOL">
                        {kol.map(k => <p key={k}>{k}</p>)}
                    </Card>
                    <Card title="Parent">
                        {hierarchyUp.map(k =>
                            <p><a href={`/site/${k}`} target={'_blank'}>{k}</a></p>)}
                    </Card>
                    <Card title="Children">
                        {hierarchyDown.map(k =>
                            <p><a href={`/site/${k}`} target={'_blank'}>{k}</a></p>)}
                    </Card>
                </Col>
                <Col span={15}>
                    <SiteCustomerSelectionTable dataSource={siteCustomerSelection} loading={false} />
                    <PersonTable dataSource={persons} loading={false} compact={true}/>
                </Col>
            </Row>
        </Card>
    }
}

const mapStateToProps = state => ({
    site: state.site.site,
    findingSite: state.site.findingSite
});

const mapDispatchToProps = dispatch => ({
    findSite: bindActionCreators(SiteActions, dispatch).findSite
});

export default connect(mapStateToProps, mapDispatchToProps)(SiteDetails)



// WEBPACK FOOTER //
// ./src/js/browse/site/SiteDetails.js